module.exports = __webpack_public_path__ + "assets/img/code3.381fb221.png";